<app-organizer-shared-layout-dashboard
  class="organizer-activity-page-list"
  [hasFooter]="true"
>
  <div class="col-span-12 md:col-span-5 md:col-start-2">
    <app-section
      [description]="
        'activity_planning.activity_list.layout.description' | translate
      "
      [title]="'activity_planning.activity_list.layout.title' | translate"
    >
      <app-router-tab-bar [tabBarLinks]="tabBarlinks">
        <router-outlet></router-outlet>
      </app-router-tab-bar>
    </app-section>
  </div>
</app-organizer-shared-layout-dashboard>
